import React from 'react';
import { ScrollLink } from "react-scroll";
import {Link} from "react-router-dom";
import '../../../styles/tutorial archive/Themes.css';

// Images
const Images = {
    noSprites: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Keep It Clean/NoSpritesFolder.png"),
    Sprites: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Keep It Clean/YesSpritesFolder.png"),
};

const otherAssets = {
    square: require("../../../Assets/Website Pack/Square.png"),
}

export default function configurableSprites() {
    return (
        <div className="about-frame">

                <div id="about">
                    <p>Configurable Audio Clips</p>
                </div>
                <div className="simple-center-align">
            <span className="normal-text">
            There's no file for this one either, because Poly Beats automatically picks these up.
                The key to make all this work is via file names. <b>Your file names have to EXACTLY match the ones used in-game (yes, this means you'll have to use .wav most of the time!), so make sure to check them carefully!</b>
                <br></br><br></br>

                This step isn't required for the game to pick up the audio clips, but to just keep our folder clean,
                let's go back to Henry (the folder we made in the Introduction page), and create a new folder in him
                called "Clips".
                <br></br><br></br>
            Cool! Now, let's list out every configurable audio clip at the moment. (these wouldn't be in the template,
            as we obviously would have some copyright protection and legal complications with giving the player easier
            access to this data.)
            <br></br><br></br>
</span>
                    <div className="about-leftalign">
                        <br></br>
                        <br></br>
                        <div className="about-leftalign">
                            <p><br/><br/>TABLE OF CONTENTS</p>

                            {/* Table of Contents */}


                            <ul className="toc">
                                <li><a href="#menu-audio">Menu Audio</a></li>
                                <li><a href="#game-audio">Game Audio</a></li>
                                <li><a href="#final-section">Final Section: Uploading Your Theme</a></li>
                            </ul>

                        </div>


                        {/* Sections to jump to */}
                        <div id="configurable-audio-clips" className="sectionFormatting">

                            <div id="menu-audio" className="sectionFormatting">
                                <h2>Menu Audio</h2>
                                <p>Most of these are reused throughout the menus, so be careful what you remake them
                                    as.</p>
                                <div className="horizontal-haver">
                                    <div className="leftright-textimage-align">
                                        <div className="just-text-align">
                                            <span className="text-white">File Name: "Menu Music.wav"</span>
                                            <span className="text-orange">Used: As ambience music in every menu.</span>
                                            <span
                                                className="text-pink">Tip: Make it loopable, <br></br>as the game will treat it <br></br>as a loopable audio clip.</span>
                                        </div>
                                        <div className="just-text-align">
                                            <span className="text-white">File Name: "ButtonClick.wav"</span>
                                            <span className="text-orange">Used: As a button click on almost every button.</span>
                                            <span className="text-pink">Tip: Don't make this an obnoxious sound.</span>
                                        </div>
                                        <div className="just-text-align">
                                            <span className="text-white">File Name: "DisabledButtonClick.wav"</span>
                                            <span className="text-orange">Used: As a button click on almost every button that cannot be pressed.</span>
                                            <span className="text-pink">Tip: Make it a sound that's communicates clearly to <br></br>the player that there's a <br></br>problem clicking that button.</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div id="game-audio" className="sectionFormatting">
                                <h2>Game Audio</h2>
                                <p>These are used in the game scene.</p>
                                <div className="excellent-spacer">
                                    <div className="leftright-textimage-align">
                                        <div className="just-text-align">
                                            <span className="text-white">File Name: "Hitsound.wav"</span>
                                            <span className="text-orange">Used: As a hitsound whenever a player successfully hits a note.</span>
                                            <span
                                                className="text-pink">Tip: Make it a sound that's not too obnoxious or over-the-top.</span>
                                        </div>
                                        <div className="just-text-align">
                                            <span className="text-white">File Name: "HoldNoteScrape.wav"</span>
                                            <span className="text-orange">Used: As a sound that plays when a player is holding down a Block (hold note).</span>
                                            <span className="text-pink">Tip: Don't make this an obnoxious sound.</span>
                                        </div>
                                        <div className="just-text-align">
                                            <span className="text-white">File Name: "Miss.wav"</span>
                                            <span className="text-orange">Used: As a sound that plays when a player misses a note.</span>
                                            <span className="text-pink">Tip: Make it a sound that communicates clearly to the player that they have a skill issue.</span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div id="next-section" className="sectionFormatting">
                                <h2>Final Section: Uploading Your Theme</h2>
                                <p>
                                    Congrats! You're done developing your theme. Now to send it out to the world.
                                </p>

                                <Link to="/tutorial-archive/Themes/Uploading-Your-Theme">
                                    <button className="fof-menu-button"><span>Uploading The Theme -></span></button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            );
            }